"use client";

import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  author: "SARAH AHMED",
  quote: "The IV Therapy at Al Shifa is transformative. I walked in feeling depleted and left with a radiant glow and renewed energy that lasted for days.",
  position: "Wellness Enthusiast"
}, {
  author: "MOHAMED KALIF",
  quote: "A truly high-class experience. The HydraFacial skin boosters are exceptional, and the attention to detail in the lounge is simply unmatched in St Cloud.",
  position: "Executive Client"
}, {
  author: "Elena Rodriguez",
  quote: "The atmosphere alone is worth the visit. It's the perfect blend of clinical excellence and pure luxury. My go-to for immune support.",
  position: "Health Advocate"
}];
export default function OQueDizemNossosClientes() {
  return <section data-section-id="224063" id="client-success-stories" className="relative py-24 md:py-32 bg-[#0A0A0A] overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/20 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-primary/10 rounded-full blur-[120px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-8 max-w-7xl">
        <div className="flex flex-col items-center text-center mb-16 md:mb-24">
          <span className="text-primary font-sans font-bold uppercase tracking-[0.3em] text-sm mb-4">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-6xl font-serif font-medium mb-6 tracking-tight text-background">
            Client <span className="italic text-primary">Success</span> Stories
          </h2>
          <div className="w-24 h-px bg-primary/40" />
        </div>

        <div className="relative px-4 md:px-16">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-8">
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-8 md:basis-1/2 lg:basis-1/2">
                  <Card className="h-full bg-card/40 backdrop-blur-md border border-primary/20 rounded-2xl shadow-2xl transition-all duration-500 hover:border-primary/40 group">
                    <CardContent className="p-8 md:p-12 flex flex-col h-full">
                      <div className="mb-8">
                        <Quote className="w-10 h-10 text-primary/20 mb-6 group-hover:text-primary/40 transition-colors duration-500" />
                        <div className="flex gap-1 text-primary mb-6">
                          {[...Array(5)].map((_, j) => <Star key={j} data-index={j} className="w-4 h-4 fill-current" />)}
                        </div>
                        <p className="font-serif text-foreground/90 text-xl md:text-2xl leading-relaxed italic">
                          "{testimonial.quote}"
                        </p>
                      </div>
                      
                      <div className="mt-auto pt-8 border-t border-primary/10 flex items-center gap-4">
                        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center border border-primary/20">
                          <span className="text-primary font-serif font-bold text-lg">
                            {testimonial.author.charAt(0)}
                          </span>
                        </div>
                        <div>
                          <p className="font-sans font-bold text-primary uppercase text-sm tracking-widest">
                            {testimonial.author}
                          </p>
                          <p className="font-sans text-muted-foreground text-xs mt-1 uppercase tracking-wider">
                            {testimonial.position}
                          </p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="flex justify-center md:block mt-12 md:mt-0">
              <CarouselPrevious className="static md:absolute bg-primary hover:bg-primary/80 border-none text-primary-foreground size-12 -left-6 lg:-left-16 transition-all duration-300 shadow-lg translate-y-0 md:-translate-y-1/2" />
              <CarouselNext className="static md:absolute bg-primary hover:bg-primary/80 border-none text-primary-foreground size-12 -right-6 lg:-right-16 transition-all duration-300 shadow-lg translate-y-0 md:-translate-y-1/2 ml-4 md:ml-0" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}